type Props = {
	projectId: string;
};

/** Project re-sync is desktop-only: nothing is rendered in the web build. */
export default function ProjectSyncButton(_props: Props) {
	return null;
}
